import { ButtonHTMLAttributes, ComponentProps, useEffect, useRef } from 'react';
import { Button } from '@consta/uikit/Button';

// TODO: добавить поддержку ref
export function UiButton(props: UiButtonProps) {
  const { htmlForm, type = 'button', ...rest } = props;

  const ref = useRef<HTMLButtonElement>(null);
  useEffect(() => {
    if (htmlForm && ref.current) ref.current.setAttribute('form', htmlForm);
  }, [ref.current, htmlForm]);

  // @ts-ignore
  return <Button ref={ref} type={type} {...rest} />;
}

export interface UiButtonProps extends ComponentProps<typeof Button> {
  htmlForm?: string;
  type?: ButtonHTMLAttributes<HTMLButtonElement>['type'];
}
